import { Controller } from "@hotwired/stimulus"

// Копирует готовый текст приглашения и на секунду меняет подпись кнопки.
export default class extends Controller {
  static values = { text: String, done: String }

  connect() {
    this.originalLabel = this.element.innerHTML
    this.busy = false
  }

  async copy(event) {
    event.preventDefault()
    if (this.busy) return

    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      return
    }

    this.busy = true
    this.element.textContent = this.doneValue
    setTimeout(() => {
      this.element.innerHTML = this.originalLabel
      this.busy = false
    }, 1500)
  }
}
